import { theme } from '@/theme';

export const styles = {
  layoutWrapper: {
    minHeight: '100vh',
    background: theme.colors.bg,
    width: '100%',
  },
} as const;
